import React, { Component } from 'react'

export default class FooterDashboard extends Component {
    render() {
        return (
            <footer className="footer-dashboard mt-auto">
                <div className="container text-azul">
                    <div>
                        <i className="fas fa-map-marker-alt me-1"></i>
                        Loja 31-15 y Buenos Aires, Riobamba &middot;{" "}
                        <i className="fas fa-phone me-1"></i>
                        03-2961680, +593 988183081 &middot;{" "}
                        <i className="fas fa-envelope me-1"></i>
                        informatica@istmas.edu.ec
                    </div>
                </div>
            </footer>
        );
    }
}
